module.exports = __webpack_public_path__ + "img/pgn07.1ea7d95b.png";